import { routes } from "../apiroutes";
import HttpService from "../httpServices";
import useMutateItem from "../useMutateItem";
import { ErrorHandler } from "../errorHandler";
// import { showErrorAlert, showSuccessAlert } from "../../utils/alert";
import useFetchItem from "../useFetchItem";

const httpService = new HttpService();


// Regular attendance reports (for branch users)
export const useGetAttendanceReports = ({ enabled = true }) => {
    const { isFetched, isLoading, error, data, refetch, isFetching, setFilter,  } = useFetchItem({
        queryKey: ["fetchAttendanceReports"],
        queryFn: (queryParams) => httpService.getData(routes.getAttendanceReports(queryParams),),
        enabled,
        retry: 2
    });

    return {
        attendanceIsFetching: isFetching,
        attendanceIsFetched: isFetched,
        attendanceIsLoading: isLoading,
        attendanceError: ErrorHandler(error),
        attendanceData: data?.data?.attendance_reports || data?.attendance_reports || [],
        attendancePagination: {
            total_count: data?.data?.total_count || data?.total_count || 0,
            page: data?.data?.page || data?.page || 1,
            page_size: data?.data?.page_size || data?.page_size || 20,
            total_pages: data?.data?.total_pages || data?.total_pages || 1,
        },
        refetchattendance: refetch,
        attendanceSetFilter: setFilter
    };
};

        // Admin attendance reports (for company admins - cross-branch access)
        export const useGetAdminAttendanceReports = ({ enabled = true, branch_id = null }) => {
            const { isFetched, isLoading, error, data, refetch, isFetching, setFilter } = useFetchItem({
                queryKey: ["fetchAdminAttendanceReports", branch_id],
                queryFn: (queryParams) => {
                    const params = { ...queryParams };
                    // Always include branch_id in params if it's provided and not 'all'
                    if (branch_id && branch_id !== 'all') {
                        params.branch_id = branch_id;
                    }
                    const url = routes.adminAttendanceReports(params);
                    
                    return httpService.getData(url);
                },
                enabled,
                retry: 2,
                staleTime: 0, // Always refetch when query key changes
                refetchOnWindowFocus: false
            });

    return {
        adminAttendanceIsFetching: isFetching,
        adminAttendanceIsFetched: isFetched,
        adminAttendanceIsLoading: isLoading,
        adminAttendanceError: ErrorHandler(error),
        adminAttendanceData: data?.data?.attendance_reports || data?.attendance_reports || [],
        adminAttendancePagination: {
            total_count: data?.data?.total_count || data?.total_count || 0,
            page: data?.data?.page || data?.page || 1,
            page_size: data?.data?.page_size || data?.page_size || 20,
            total_pages: data?.data?.total_pages || data?.total_pages || 1,
        },
        refetchAdminAttendance: refetch,
        adminAttendanceSetFilter: setFilter
    };
};

export const useRecentEntries = ({ enabled = true, branch_id = null }) => {
    const { isFetched, isLoading, error, data, refetch, isFetching, setFilter } = useFetchItem({
        queryKey: ["recentEntries", branch_id],
        queryFn: (params) => {
            const queryParams = { ...params };
            if (branch_id && branch_id !== 'all' && branch_id !== undefined) {
                queryParams.branch_id = branch_id;
            }
            return httpService.getData(routes.recentEntries(queryParams));
        },
        enabled,
        retry: 2,
        refetchInterval: 180000,
        staleTime: 0, // Always refetch when branch changes
        refetchOnWindowFocus: false
    });

    return {
        recentEntriesIsFetching: isFetching,
        recentEntriesIsFetched: isFetched,
        recentEntriesIsLoading: isLoading,
        recentEntriesError: ErrorHandler(error),
        recentEntriesData: data?.data || [],
        refetchRecentEntries: refetch,
        recentEntriesFilter: setFilter,
    };
};

export const useAttendanceSummary = ({ enabled = true, branch_id = null }) => {
    const { isFetched, isLoading, error, data, refetch, isFetching } = useFetchItem({
        queryKey: ["attendanceSummary", branch_id],
        queryFn: () => {
            const params = {};
            if (branch_id && branch_id !== 'all' && branch_id !== undefined) {
                params.branch_id = branch_id;
            }
            const url = routes.attendanceSummary(params);
            return httpService.getData(url);
        },
        enabled,
        retry: 2,
        staleTime: 0, // Always refetch when branch changes
        refetchOnWindowFocus: false
    });

    return {
        attendanceSummaryIsFetching: isFetching,
        attendanceSummaryIsFetched: isFetched,
        attendanceSummaryIsLoading: isLoading,
        attendanceSummaryError: ErrorHandler(error),
        attendanceSummaryData: data?.data || {},
        refetchAttendanceSummary: refetch
    };
};

export const useWeeklyAttendanceSummary = ({ enabled = true, branch_id = null }) => {
    const { isFetched, isLoading, error, data, refetch, isFetching } = useFetchItem({
        queryKey: ["weeklyAttendanceSummary", branch_id],
        queryFn: () => {
            const params = {};
            if (branch_id && branch_id !== 'all' && branch_id !== undefined) {
                params.branch_id = branch_id;
            }
            const url = routes.weeklyAttendanceSummary(params);
            return httpService.getData(url);
        },
        enabled,
        retry: 2,
        staleTime: 0, // Always refetch when branch changes
        refetchOnWindowFocus: false
    });

    return {
        weeklyAttendanceSummaryIsFetching: isFetching,
        weeklyAttendanceSummaryIsFetched: isFetched,
        weeklyAttendanceSummaryIsLoading: isLoading,
        weeklyAttendanceSummaryError: ErrorHandler(error),
        weeklyAttendanceSummaryData: data?.data || {},
        refetchWeeklyAttendanceSummary: refetch
    };
};

// Trigger auto clock-out job (Admin only)
export const useTriggerAutoClockout = () => {
    const { mutate, mutateAsync, isLoading, error, data } = useMutateItem({
        mutationFn: () => httpService.postData({}, routes.triggerAutoClockout()),
        queryKeys: ["fetchAdminAttendanceReports", "fetchAttendanceReports"],
    });

    return {
        triggerAutoClockout: mutate,
        triggerAutoClockoutAsync: mutateAsync,
        triggerAutoClockoutIsLoading: isLoading,
        triggerAutoClockoutError: ErrorHandler(error),
        triggerAutoClockoutData: data?.data || data,
    };
};
